var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('tasks-list',{attrs:{"title":_vm.title,"headers":_vm.headers,"data":_vm.data,"response":_vm.response,"loading":_vm.loading},on:{"details":_vm.previewFn,"reload":_vm.loadTasks,"new":_vm.newFn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }